import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface UserManualsState {
  manuals: any
  manual: any
  manualDelete: any
  manualsError: any
}

export const useUserManualsStore = defineStore('userManuals', {
  state: (): UserManualsState => ({
    manuals: null,
    manual: null,
    manualDelete: null,
    manualsError: null,
  }),

  getters: {
    getManuals: (state) => state.manuals,
    getManualCreated: (state) => state.manual,
    getManualDeleted: (state) => state.manualDelete,
    getManualsError: (state) => state.manualsError,
  },

  actions: {
    async fetchManuals() {
      try {
        const response = await api().get('configuration/user-manual')
        this.manuals = response.data
      } catch (error: any) {
        this.manualsError = error.response?.data
      }
    },

    async deleteManual(manualId: string | number) {
      try {
        const response = await api().get('configuration/user-manual/delete/' + manualId)
        this.manualDelete = response.data
      } catch (error: any) {
        this.manualsError = error.response?.data
      }
    },

    async createManual(data: any) {
      try {
        const response = await api().post('configuration/user-manual/add', data)
        this.manual = response.data
      } catch (error: any) {
        this.manualsError = error.response?.data
      }
    },
  },
})
